import {
  Avatar, ListItem, ListItemAvatar, ListItemText
} from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { ListItemButton } from '@mui/material';
import { useStyles } from './styles';
import { UserListingSearch } from './UserListingSearch';

interface IUserListingProps {
  UserList: {
    id: string;
    name: string;
    email: string;
    picture: string;
  }[];
  hidden?: boolean;
  setSelectedClient?: any;
  selectedClient?: any;
  loading?: boolean;
}

export const MINIMUM_SEARCH_LENGTH = 2;

const getUserInitials = (name: string) => {
  const nameParts = name.trim().split(/\s+/).filter(Boolean);

  if (nameParts.length === 0) return "";
  if (nameParts.length === 1) return nameParts[0].slice(0, 2).toUpperCase();

  return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
};

const UserListing: React.FC<IUserListingProps> = ({
  UserList, hidden, setSelectedClient, selectedClient, loading = false
}) => {
  const Styles = useStyles();
  const [searchQuery, setSearchQuery] = useState("");
  const [onSearchFocus, setOnSearchFocus] = useState(false);

  const filteredUsers = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    const matches = query.length < MINIMUM_SEARCH_LENGTH
      ? [...UserList]
      : UserList.filter((user) => {
        const name = user.name.toLowerCase();
        return (
          name.startsWith(query)
          || name.split(/\s+/).some((word) => word.startsWith(query))
        );
      });

    if (
      selectedClient
      && !matches.some((user) => user.id === selectedClient.id)
    ) {
      matches.unshift(selectedClient);
    }

    return matches.sort((firstUser, secondUser) => (
      firstUser.name.localeCompare(secondUser.name, "pt-BR", {
        sensitivity: "base",
      })
    ));
  }, [searchQuery, UserList, selectedClient]);

  const matchSelectedClient = (user: any) => {
    if (selectedClient?.id === user.id) {
      return Styles.listingItemSelected;
    }
    return "";
  };

  useEffect(() => {
    if (selectedClient && !onSearchFocus) {
      setSearchQuery(selectedClient.name);
    }
  }, [selectedClient, onSearchFocus]);

  if (hidden) {
    return null;
  }

  const showNoResults = !loading
    && searchQuery.trim().length >= MINIMUM_SEARCH_LENGTH
    && filteredUsers.length === 0;

  return (
    <div>
      <ListItem className={Styles.listingContainer}>
        <UserListingSearch
          hidden={hidden}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          setOnSearchFocus={setOnSearchFocus}
        />
        <div className={Styles.itemContainer}>
          {loading && <div className={Styles.listingMessage}>Carregando...</div>}
          {showNoResults && (
            <div className={Styles.listingMessage}>Nenhum usuário encontrado</div>
          )}
          {filteredUsers.map((user) => (
            <ListItemButton
              key={user?.id}
              onClick={
              () => setSelectedClient(user)
            }
            >
              <div className={
                matchSelectedClient(user) ? Styles.listingItemSelected : Styles.listingItem
              }
              >
                <ListItemAvatar>
                  <Avatar aria-label={user.name}>
                    {getUserInitials(user.name)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={user.name} />
              </div>
            </ListItemButton>
          ))}
        </div>
      </ListItem>
    </div>
  );
};

export { UserListing };
